module.exports = __webpack_public_path__ + "img/homelist1.30585814.png";